import { render, staticRenderFns } from "./InitDataWindow.vue?vue&type=template&id=0484a273&scoped=true&"
import script from "./InitDataWindow.vue?vue&type=script&lang=js&"
export * from "./InitDataWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484a273",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0484a273')) {
      api.createRecord('0484a273', component.options)
    } else {
      api.reload('0484a273', component.options)
    }
    module.hot.accept("./InitDataWindow.vue?vue&type=template&id=0484a273&scoped=true&", function () {
      api.rerender('0484a273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/InitDataWindow.vue"
export default component.exports